import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { FileUpload } from "primereact/fileupload";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import { Reorder } from "framer-motion";


interface IImage {
    id: number;
    imageFileName: string;
    isCoverPhoto?: boolean;
    order?: number;
}

interface IProps {
    visible: boolean;
    onHide: () => void;
    images: IImage[];
    title?: string;
    toast: any;
    roomId: number;
    reloadImages: () => void;
}

export const ImageGalleryDialog = (props: IProps) => {
    const [uploading, setUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [localImages, setLocalImages] = useState<IImage[]>([]);
    const fileUploadRef = useRef<FileUpload>(null);
    const [isOrderChanged, setIsOrderChanged] = useState(false);


    useEffect(() => {
        const sorted = [...props.images].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        setLocalImages(props.images);
        setIsOrderChanged(false);
    }, [props.images]);

    //  Toggle cover photo
    const handleCoverPhotoChange = async (image: IImage) => {
        const response = await Fetch(`City/ToggleCoverPhoto/${image.id}`, "PUT", null, null, props.toast);
        if (response) {
            setLocalImages(prev =>
                prev.map(img => ({
                    ...img,
                    isCoverPhoto: img.id === image.id
                }))
            );
            props.toast.current.show({ severity: "success", summary: "Updated", detail: "Cover photo updated successfully", life: 2000, });
            props.reloadImages();
        }
    };


    // Delete existing image
    const handleDelete = async (id: number) => {
        const response = await Fetch(`City/DeleteImage/${id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", detail: "Image deleted", life: 3000 });
            props.reloadImages();
        }
    };

    // When user selects new images
    const onSelectFiles = (event: any) => {
        const files = event.files as File[];
        setSelectedFiles((prev) => [...prev, ...files]);
    };

    const handleSave = async () => {
        if (selectedFiles.length === 0) {
            props.toast.current.show({ severity: "warn", detail: "No image selected", life: 3000 });
            return;
        }

        setUploading(true);
        for (const file of selectedFiles) {
            const formData = new FormData();
            formData.append("images", file);
            formData.append("cityId", props.roomId.toString());

            const response = await Fetch("city/addImagess", "POST", formData, null, props.toast);
            if (response) {
                setUploading(false);
                props.toast.current.show({ severity: "success", detail: "Images uploaded successfully", life: 3000 });
                setSelectedFiles([]);
                fileUploadRef.current?.clear();
                props.reloadImages();
            }
            setUploading(false);
            setSelectedFiles([]);
            fileUploadRef.current?.clear();
            props.reloadImages();
        }
        // setUploading(false);

        // props.toast.current.show({ severity: "success", detail: "Images uploaded successfully", life: 3000 });

        // setSelectedFiles([]);
        // fileUploadRef.current?.clear();

        // props.reloadImages();
    };


    const confirmDialogcover = (img: any) => {
        confirmDialog({
            message: 'Are you sure you want to this image as cover photo?',
            header: 'Confirm ',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => {
                handleCoverPhotoChange(img)
            },
            reject: () => {
            }
        });
    };


    // Save reordered images
    const saveReorder = async () => {
        const reorderedData = localImages.map((img, index) => ({
            id: img.id,
            order: index + 1,
        }));
        const response = await Fetch("City/UpdateImageOrder", "PUT", reorderedData, null, props.toast);
        if (response) {
            props.toast.current.show({
                severity: "success",
                detail: "Image order updated successfully",
                life: 2000,
            });
            setIsOrderChanged(false);
            props.reloadImages();
        }
    };


    return (
        <Dialog visible={props.visible} header={
            <span className="text-blue-700 font-semibold text-lg">
                Upload Images for {props.title}
            </span>
        } style={{ width: "60vw" }} onHide={props.onHide} >
            {/* <div className="card p-4 mb-4 shadow-sm border-1">
                <FileUpload ref={fileUploadRef} mode="basic" name="file" accept="image/*" multiple customUpload
                    uploadHandler={() => { }} onSelect={onSelectFiles} chooseLabel="Choose Images" className="w-full mb-3" />
                <div className="flex justify-content-end">
                    <Button label={uploading ? "Saving..." : "Save"} icon="" loading={uploading} onClick={handleSave} />
                </div>
            </div> */}

            <div className="card p-4 mb-4 shadow-sm border-1">
                <div className="flex align-items-center justify-content-between gap-3 flex-wrap">
                    <FileUpload ref={fileUploadRef} mode="basic" name="file" accept="image/*"
                        multiple customUpload uploadHandler={() => { }} onSelect={onSelectFiles} chooseLabel="Choose Images" className="flex-1" />
                    <Button label={uploading ? "Saving..." : "Save"} icon="" loading={uploading} onClick={handleSave} />

                </div>
            </div>


            {/* Gallery Section */}
            <div className="border-top-1 pt-3">
                <h6 className="mb-3">Uploaded Images</h6>

                {localImages.length > 0 ? (
                    <>
                        <Reorder.Group axis="y"
                            values={localImages}
                            onReorder={(newOrder: any) => {
                                setLocalImages(newOrder);
                                setIsOrderChanged(true);
                            }}
                            className="flex flex-column gap-3"
                        >
                            {localImages.map((img) => (
                                <Reorder.Item key={img.id} value={img} className="p-2 border-1 surface-border border-round-md flex align-items-center justify-content-between" >
                                    <div className="flex align-items-center gap-3">
                                        <img src={`${baseUrl}city/streamImage?fileName=${img.imageFileName}`}
                                            alt=""
                                            style={{
                                                width: 80, height: 50, objectFit: "cover", borderRadius: "8px", border: img.isCoverPhoto ? "3px solid #4caf50"
                                                    : "1px solid #ddd",
                                            }}
                                        />
                                        <div className="flex align-items-center gap-2">
                                            <Checkbox inputId={`cover-${img.id}`} checked={img.isCoverPhoto || false} onChange={() => confirmDialogcover(img)} />
                                            <label htmlFor={`cover-${img.id}`} className="text-sm">
                                                Cover Photo
                                            </label>
                                        </div>
                                    </div>

                                    <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-sm" onClick={() => handleDelete(img.id)} tooltip="Delete" />
                                </Reorder.Item>
                            ))}
                        </Reorder.Group>

                        {isOrderChanged && (
                            <div className="flex justify-content-end mt-3">
                                <Button label="Save Order" onClick={saveReorder} />
                            </div>
                        )}
                    </>
                ) : (
                    <p>No images found</p>
                )}
            </div>
        </Dialog>
    );
};
